import { View } from "@react-pdf/renderer";
import {


} from "components/Resume/ResumePDF/common";
import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeSkills } from "lib/redux/types";
import { ResumePDFDescription } from "./common";
import { TemplateSixteenSection } from "./common/sections";

export const Skills = ({
  heading,
  skills,
  themeColor,
}: {
  heading: string;
  skills: ResumeSkills;
  themeColor: string;
}) => {
  const { descriptions } = skills;
  return (
    <TemplateSixteenSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }}>
        <ResumePDFDescription items={descriptions} />
      </View>
    </TemplateSixteenSection>
  );
};
